"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormArrayField = void 0;
const tslib_1 = require("tslib");
const components_1 = require("@bluebase/components");
const core_1 = require("@bluebase/core");
const formik_1 = require("formik");
const react_1 = tslib_1.__importDefault(require("react"));
const FormFields_1 = require("../FormFields");
const FieldWrapper = ({ field, children }) => {
    const { theme } = core_1.useTheme();
    return (react_1.default.createElement(components_1.View, { testID: "fieldTest", key: field.name, style: {
            flex: 1,
            margin: -theme.spacing.unit,
        } }, children));
};
const defaultStyles = (theme) => ({
    root: {
        paddingVertical: theme.spacing.unit,
    },
    fieldActions: {
        padding: theme.spacing.unit * 2,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-end',
    },
    fieldItemActions: {
        justifyContent: 'center',
    },
    titleWrapper: {
        paddingHorizontal: theme.spacing.unit * 2,
        paddingVertical: theme.spacing.unit,
    },
    label: {
        color: theme.palette.text.secondary,
    },
    helperText: Object.assign(Object.assign({}, theme.typography.caption), { color: theme.palette.text.secondary, paddingTop: theme.spacing.unit / 2 }),
    itemWrapper: {
        borderColor: theme.palette.divider,
        borderRadius: theme.shape.borderRadius,
        borderWidth: 1,
        marginHorizontal: theme.spacing.unit * 2
    },
    item: {
        flexDirection: 'row',
        padding: theme.spacing.unit,
        borderBottomColor: theme.palette.divider,
        borderBottomWidth: 1,
    },
});
/**
 * A component that renders form actions, i.e. submit or reset buttons
 * @param props
 */
const FormArrayField = (props) => {
    const { style, label, addButtonLabel, helperText } = props;
    const { theme } = core_1.useTheme();
    const styles = core_1.useStyles('FormArrayField', props, defaultStyles);
    const [field] = formik_1.useField(props.name);
    const { value = [], name } = field;
    function getFields(index) {
        return (props.fields || []).map(f => (Object.assign(Object.assign({}, f), { name: `${name}[${index}].${f.name}` })));
    }
    const RemoveFields = (remove, index) => () => {
        return remove(index);
    };
    const PushFields = (push) => () => {
        return push({});
    };
    return (react_1.default.createElement(formik_1.FieldArray, { name: name }, ({ push, remove }) => (react_1.default.createElement(components_1.View, { style: [styles.root, style] },
        react_1.default.createElement(components_1.View, { style: styles.titleWrapper },
            react_1.default.createElement(components_1.Subtitle1, { style: styles.label }, label),
            helperText ? react_1.default.createElement(components_1.Body2, { style: styles.helperText }, helperText) : null),
        react_1.default.createElement(components_1.View, { style: styles.itemWrapper },
            value.map((_val, index) => (react_1.default.createElement(components_1.View, { key: index, style: styles.item, testID: "form-array-item" },
                react_1.default.createElement(components_1.View, { style: { flex: 1 } },
                    react_1.default.createElement(FormFields_1.FormFields, Object.assign({}, props, { fields: getFields(index), FieldWrapper: FieldWrapper }))),
                react_1.default.createElement(components_1.View, { style: styles.fieldItemActions, testID: "form-item-actions" },
                    react_1.default.createElement(components_1.IconButton, { name: "delete", size: theme.spacing.unit * 2, onPress: RemoveFields(remove, index) }))))),
            react_1.default.createElement(components_1.View, { style: styles.fieldActions },
                react_1.default.createElement(components_1.Button, { title: addButtonLabel, variant: "outlined", icon: { type: 'icon', name: 'plus' }, onPress: PushFields(push) })))))));
};
exports.FormArrayField = FormArrayField;
exports.FormArrayField.displayName = 'FormArrayField';
exports.FormArrayField.defaultProps = {
    addButtonLabel: 'Add',
};
